import React from "react";
import "./subtitles.scss";

const Subtitles = (props) => {
  return <div class="subtitles">{props.children}</div>;
};

export default Subtitles;
